export default __webpack_public_path__ + "assets/images/onboarding/97e75856d5307206fb6aeddfb9a5c0ae.mp4";